export const columns = [
  { title: 'Name', dataIndex: 'name' },
  { title: 'User role', dataIndex: 'role' },
  { title: 'Email', dataIndex: 'email' },
];
